module.exports = __webpack_public_path__ + "static/media/parallax-bg-10.3ed47b87.jpg";